import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { environment } from '../../../environments/environment';
import { CriteriaObject } from 'ng2-app/models/dto/criteria-object.model';

interface BorrowerStatus {
  id: number;
  status: string;
}
interface BorrowerStatusResponse {
  data: BorrowerStatus[];
}

export interface BorrowerStatusOption {
  id: number;
  status: string;
  label?: string;
  deprecated?: boolean;
  borrower_stage_lookup: {
    id: number;
    stage: string;
    label: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class BorrowerStatusesService {

  constructor(private http: ApiHttpClient) { }

  get() {
    // criteria object isn't being used..
    const params: CriteriaObject = {
      criteria: {
        'deprecated': {'==': 0}
      }
    };
    const query = encodeURIComponent(JSON.stringify(params));
    return this.http.get<BorrowerStatusOption[]>(`${environment.API_URL}/borrower-status-lookup`);
  }
}
